<script lang="ts">
    import RangeSlider from "svelte-range-slider-pips/src/RangeSlider.svelte"

    export let min
    export let max
    export let unit = ""
    export let rangeStart: number
    export let rangeEnd: number
    export let tolerance: number
    export let numberFormat: Function | undefined

    let _numberFormat = (n: number) => {
        if (numberFormat) {
            return numberFormat(n)
        }
        return n
    }

    export const reset = () => {
        range = [min - (tolerance || 0), max + (tolerance || 0)]
    }

    let range = [rangeStart || min - (tolerance || 0), rangeEnd || max + (tolerance || 0)]

    $: {
        rangeStart = range[0] >= min ? range[0] : undefined
        rangeEnd = range[1] <= max ? range[1] : undefined
    }
</script>

{#if min && max}
    <div class="rangeslider">
        <div class="slider_holder">
            <RangeSlider min="{min - (tolerance || 0)}" max="{max + (tolerance || 0)}" bind:values="{range}" />
        </div>
        <div class="values">
            <span class="value1">{_numberFormat(range[0])} {unit}</span>
            <span>bis</span>
            <span class="value2">{_numberFormat(range[1])} {unit}</span>
        </div>
    </div>
{/if}

<style lang="less">
    @import "../../css/variables.less";

    .rangeslider {
        .slider_holder {
            overflow: inherit;
        }

        @media (max-width: 850px) {
            // margin-top: -15px;
            .slider_holder {
                padding: 0px 0px;
            }
        }

        .values {
            margin-top: 0px;
            .flex();
            align-items: center;
            justify-content: center;
            @media (max-width: 1300px) {
                font-size: 0.7rem;
            }
            @media (max-width: 600px) {
                font-size: 0.9rem;
            }
            span {
                margin: 0px 4px;
                line-height: 1;
                &:nth-child(1),
                &:nth-child(3) {
                    color: var(--primary);
                    font-weight: 700;
                }
            }
        }
    }
</style>
